import React from 'react';

import { useSelector } from 'react-redux';
import { selectSliderValue } from './selectors';

const gradientFromValue = (value) => {
  return {background: `linear-gradient(to right, #007AFC 0%, #007AFC ${value}%, rgba(86, 97, 113, 0.7) ${value}%, rgba(86, 97, 113, 0.7) 100%)`};
}

function Slider({ onChange }) {
  const sliderValue = useSelector((state) => selectSliderValue(state));

  return (
    <div className="slidecontainer">
      <input type="range" style={gradientFromValue(sliderValue)} min="0" max="100" value={sliderValue} className="slider" id="myRange" onChange={onChange} />
    </div>
  ); 
}

export default Slider;
